export default "__VITE_PUBLIC_ASSET__9233409f__"